export abstract class DatatableRowStyler {
  abstract applyRowStyling(row: any): any;
}
